// extracted by mini-css-extract-plugin
module.exports = {"container":"activityList-module--container--2g5s2","intro":"activityList-module--intro--3K3-F","link":"activityList-module--link--1vihH"};